import React, { ReactElement } from 'react';
import { Button, Flex } from '@chakra-ui/react';
import { FilesIcon, VisibilityIcon } from 'assets/icons/v2';

type Props = {
  onDownload: () => void;
  onCopy: () => void;
  hasCopied: boolean;
};

export const QRActionButtons = ({ onDownload, onCopy, hasCopied }: Props): ReactElement => {
  return (
    <Flex gap="l" wrap="wrap" justify="center">
      <Button
        bg="grey.white"
        border="default"
        borderColor="border.accent"
        color="text.secondary"
        px="xl"
        py="10px"
        borderRadius="m"
        gap="5px"
        minWidth="fit-content"
        onClick={onDownload}
        textStyle="body.m.regular"
        fontWeight="regular"
        _hover={{ bg: 'background.canvas' }}
      >
        <VisibilityIcon boxSize="13.5px" />
        QR-Code herunterladen
      </Button>
      <Button
        bg="grey.white"
        border="default"
        borderColor="border.accent"
        color="text.secondary"
        px="xl"
        py="10px"
        borderRadius="m"
        gap="5px"
        onClick={onCopy}
        minWidth="fit-content"
        disabled={hasCopied}
        fontWeight="regular"
        textStyle="body.m.regular"
        _hover={{ bg: 'background.canvas' }}
      >
        <FilesIcon boxSize="13.5px" />
        {hasCopied ? 'Link kopiert' : 'Link kopieren'}
      </Button>
    </Flex>
  );
};
